import React, { useState, useEffect } from 'react'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
} from 'rsuite'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'

export default function ProjectClosedLateForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  onClear,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [dataDate, setDataDate] = useState(null)
  const [clearVal, setClearVal] = useState()
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()

  useEffect(() => {
    setProjectCode('')
    setProjectName('')
  }, [onClear])

  return (
    <>
      <Form>
        <Row>
          <Col lg={8} md={8} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
            {schema.projectCode.label}
            <ErrorMessage error={errors[schema.projectCode.name]} />
            <Input
              name={schema.projectCode.name}
              // defaultValue={schema.projectCode.value}
              value={projectCode}
              onChange={(value) => setProjectCode(value)}
              placeholder={schema.projectCode.hint || `ระบุ${schema.projectCode.label}`}
              inputRef={register()}
            />
          </Col>
          <Col lg={16} md={16} sm={24} xs={24} style={{ marginTop: '5px', padding: '8px' }}>
            {schema.projectName.label}
            <ErrorMessage error={errors[schema.projectName.name]} />
            <Input
              name={schema.projectName.name}
              // defaultValue={clearVal}
              value={projectName}
              onChange={(value) => setProjectName(value)}
              placeholder={schema.projectName.hint || `ระบุ${schema.projectName.label}`}
              inputRef={register()}
            />
          </Col>
        </Row>
      </Form>
    </>
  )
}
